import { invokeToastDispatch } from './toastDispatch';
import type { ToastInput } from '../types/toast';

export const toast = {
  success: (input: ToastInput) => invokeToastDispatch('success', input),
  warning: (input: ToastInput) => invokeToastDispatch('warning', input),
  error: (input: ToastInput) => invokeToastDispatch('error', input),
  info: (input: ToastInput) => invokeToastDispatch('info', input),
};
